module.exports = __webpack_public_path__ + "img/202.df312288.jpg";